import { SettingsPage } from 'Features/Projects/Scenarios/EditSettings/SettingsPage'

import { useSettingsContext } from 'Features/Projects/Scenarios/EditSettings/EditSettings.types'

import { SiteStockFlowTable } from './SiteStockFlow.Table'
import { useSiteStockFlow } from './SiteStockFlow.data'

export const SiteStockFlowView = () => {
  const { state } = useSettingsContext()
  const { projectId, scenarioId } = state

  const { data: siteStockFlowData, isLoading } = useSiteStockFlow({
    projectId,
    scenarioId,
  })

  return (
    <SettingsPage title="Site stock flow">
      <SiteStockFlowTable
        data={siteStockFlowData ?? []}
        isLoading={isLoading}
      />
    </SettingsPage>
  )
}
